import React from 'react';
import { Linkedin, Twitter, MessageSquare, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="footer" className="bg-gray-900 dark:bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="py-16 lg:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* Column 1: Logo, tagline and social */}
            <div className="lg:col-span-2">
              <div className="flex items-center space-x-2 mb-6">
                <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-500 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-lg">P</span>
                </div>
                <div className="text-2xl font-bold">
                  propertyads<span className="text-purple-400">.ai</span>
                </div>
              </div>
              
              <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
                Next-generation marketing platform specifically designed for Dubai real estate professionals. Transform your lead generation with AI-powered automation.
              </p>
              
              {/* Social links */}
              <div className="flex space-x-4 mb-8">
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors duration-200"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors duration-200"
                  aria-label="Twitter"
                >
                  <Twitter size={20} />
                </a>
                <a 
                  href="#" 
                  className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-lg flex items-center justify-center transition-colors duration-200"
                  aria-label="Contact"
                >
                  <MessageSquare size={20} />
                </a>
              </div>
              
              {/* Contact info */}
              <div className="space-y-3">
                <div className="flex items-center text-gray-300">
                  <Mail size={16} className="mr-3 text-purple-400" />
                  <span>support@propertyads.ai</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <Phone size={16} className="mr-3 text-purple-400" />
                  <span>+971 XX XXX XXXX</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <MapPin size={16} className="mr-3 text-purple-400" />
                  <span>Dubai, UAE</span>
                </div>
              </div>
            </div>
            
            {/* Column 2: Navigation */}
            <div>
              <h4 className="text-lg font-bold mb-6 text-white">Navigation</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#hero" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#features" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#solution" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#pricing" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="#blog" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="#footer" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Column 3: Resources & Legal */}
            <div>
              <h4 className="text-lg font-bold mb-6 text-white">Resources</h4>
              <ul className="space-y-3 mb-8">
                <li>
                  <a href="#help" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="#api" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    API Documentation
                  </a>
                </li>
                <li>
                  <a href="#guides" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Marketing Guides
                  </a>
                </li>
              </ul>
              
              <h5 className="font-semibold mb-4 text-white">Legal</h5>
              <ul className="space-y-3">
                <li>
                  <a href="/privacy" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/terms" className="text-gray-300 hover:text-purple-400 transition-colors duration-200">
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Bottom section */}
        <div className="py-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} propertyads.ai. All rights reserved.
            </p>
            <div className="flex items-center mt-4 md:mt-0">
              <span className="text-gray-400 text-sm mr-4">Made with ❤️ in Dubai</span>
              <div className="flex items-center">
                <div className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></div>
                <span className="text-gray-400 text-sm">All systems operational</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;